import { createContext } from 'react';
import { Location } from '../helpers/api/types';

export type LocationsContextType = {
  locations: Location[];
  selectedLocation: Location;
  setLocations: (locations: Location[], resetLocations?: boolean) => void;
  setSelectedLocation: (location: Location) => void;
};

const defaultLocationsContextValue: LocationsContextType = {
  locations: [],
  selectedLocation: {} as Location,
  setLocations: () => {},
  setSelectedLocation: () => {},
};

const LocationsContext = createContext<LocationsContextType>(defaultLocationsContextValue);

export default LocationsContext;
